<div class="test">
  <div [formGroup]="form">

    <fc-name-details
      [baseId]="baseId"
      [form]="nameDetailsFormGroup"
      [itemContext]="itemContext"
      [listItem]="listItem"
      [isSubmitted]="isSubmitted"
    >
    </fc-name-details>

    <hr />

    <fc-other-information
      [baseId]="baseId"
      [form]="otherInformationFormGroup"
      [itemContext]="itemContext"
      [listItem]="listItem"
      [isSubmitted]="isSubmitted"
    >
    </fc-other-information>

    <hr />
    <h4
      id="{{ baseId }}-addresses-subtitle"
      translate
    >
      Addresses
      <span style="font-size: 15px;margin-left: 10px;">
        <ng-container *ngIf="FindControlIdService.ViewFindPerson !== itemContext.findControlId">
          <a (click)="onOpenCopyContactInfo()">Copy Contact Info</a>
        </ng-container>
        <span class="ml-2">
          <mat-checkbox
            id="{{ baseId }}-undeliverable-to-primary-address"
            formControlName="undeliverableToPrimaryAddress"
            translate
          >
            Mail is undeliverable to Primary Address
          </mat-checkbox>
        </span>
      </span>
    </h4>
    <h4
      id="{{ baseId }}-primary-address-subtitle"
      translate
    >Primary Address</h4>
    <section>

      <!-- Address Component -->
      <fc-address-list
        [baseId]="baseId + 'primary-address'"
        [form]="primaryAddressFormGroup"
        [listItem]="listItem.Address1"
        [isSubmitted]="isSubmitted"
        [itemContext]="itemContext"
      >
      </fc-address-list>
      <!-- Address Component -->

    </section>

    <hr />
    <h4
      id="{{ baseId }}-secondary-address-subtitle"
      translate
    >Secondary Address</h4>
    <section>
      <fc-address-list
        [baseId]="baseId + 'secondary-address'"
        [form]="secondaryAddressFormGroup"
        [listItem]="listItem.Address2"
        [isSubmitted]="isSubmitted"
        [itemContext]="itemContext"
      >
      </fc-address-list>
    </section>

    <hr />
    <h4
      id="{{ baseId }}-contact-information-subtitle"
      translate
    >Contact Information</h4>
    <section class="flex-row-generic">

      <div class="flex-item-two-columns">
        <table class="table emds-table table-striped table-borderless mt-2" formArrayName="phones">
          <thead>
          <tr>
            <th style="width: 50%">Phone Number</th>
            <th style="width: 50%">Phone Type</th>
            <th colspan="2">Marketing</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of phonesFormArray.controls; index as i" [formGroupName]="i">
            <td>
              <div class="form-group">
                <input
                  #phoneNumber
                  id="{{ baseId }}-phone-row-{{i}}-phone-number"
                  type="text"
                  class="form-control"
                  [ngClass]="{ error: showErrors(row.get('phoneNumber')) }"
                  [maxlength]="fcListValidation.validations.PhoneNumber.MaxLength"
                  [specialCharacters]="['(', ')', 'x', ' ', '-']"
                  [dropSpecialCharacters]="false"
                  mask="000-0000||(000)000-0000 x0000000"
                  formControlName="phoneNumber"
                />
                <div
                  *ngIf="showErrors(row.get('phoneNumber'))"
                  id="{{ baseId }}-warning-text-phone-number"
                  class="incorrect-input"
                  translate
                >
                  {{
                  row.get('phoneNumber')?.errors
                    | fcListValidation : 'Phone Number' : { pattern: 'A phone number must have at least 7 digits or 10 or more digits' }
                  }}
                </div>
              </div>
            </td>
            <td>
              <ap-findcontrol
                id="{{ baseId }}-phone-row-{{i}}-phone-type"
                controlName="phoneTypeUid"
                [selectedPks]="row.get('phoneTypeUid').value"
                [baseId]="baseId"
                [form]="form"
                [apFormGroup]="row"
                [singleSelect]="true"
                [findControlId]="FindControlIdService.ListPhoneType"
                [required]="row.get('phoneNumber').value && row.get('phoneNumber').valid"
                [disabled]="!(row.get('phoneNumber').value && row.get('phoneNumber').valid)"
                (chipsChange)="onPhoneTypeDataPopulate($event, row.get('phoneType'), row.get('isPhoneSmsEnabled'))"
              >
              </ap-findcontrol>
            </td>
            <td>
              <div class="emds icons-container"
                   [class.hide]="!row.get('phoneType').value"
              >
                <a role="button">
                  <mat-icon *ngIf="row.get('isPhoneSmsEnabled').value"
                            class="material-icons"
                            style="color: rgb(0, 128, 55);"
                  >mobile_friendly</mat-icon>
                </a>
                <a role="button">
                  <mat-icon *ngIf="!row.get('isPhoneSmsEnabled').value"
                            class="material-icons"
                  >smartphone</mat-icon>
                </a>
              </div>
            </td>

            <td>
              <mat-checkbox
                id="{{ baseId }}-phone-row-{{i}}-marketing"
                formControlName="marketing"
                translate
              ></mat-checkbox>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="form-group">
          <label translate>Preferred Contact Method</label>
          <mat-select formControlName="preferredContactMethod">
            <mat-option *ngFor="let item of preferredContactMethodItems" [value]="item">{{ item }}</mat-option>
          </mat-select>
        </div>
      </div>

      <div class="flex-item-two-columns">
        <table class="table emds-table table-striped table-borderless mt-2" formArrayName="emails">
          <thead>
          <tr>
            <th>Email</th>
            <th>Marketing</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of emailsFormArray.controls; index as i" [formGroupName]="i">
            <td>
              <div class="form-group">
                <input
                  id="{{ baseId }}-email-row-{{i}}-email"
                  type="text"
                  class="form-control"
                  [ngClass]="{ error: showErrors(row.get('email')) }"
                  [maxlength]="500"
                  formControlName="email"
                />
                <div
                  *ngIf="showErrors(row.get('email'))"
                  id="{{ baseId }}-warning-text-email{{i}}"
                  class="incorrect-input"
                  translate
                >
                  {{ row.get('email')?.errors | fcListValidation : 'Email' }}
                </div>
                <div *ngIf="row.get('marketing').enabled" class="info-message-gray">
                  <ng-container *ngIf="row.get('marketing').value">User opted-in Patient Marketing</ng-container>
                  <ng-container *ngIf="!row.get('marketing').value">User opted-out Patient Marketing</ng-container>
                </div>
              </div>
            </td>
            <td>
              <mat-checkbox
                id="{{ baseId }}-email-row-{{i}}-marketing"
                formControlName="marketing"
                translate
              ></mat-checkbox>
            </td>
          </tr>
          </tbody>
        </table>

        <!-- Undeliverable to Primary Address Checkbox -->
        <div class="checkbox-group">
          <mat-checkbox
            id="{{ baseId }}-declined-or-has-no-email-address"
            formControlName="declinedOrHasNoEmailAddress"
            translate
          >
            Declined or has no email address
          </mat-checkbox>
        </div>
        <!-- Undeliverable to Primary Address Checkbox -->
      </div>
    </section>

    <div class="form-group full-control">
      <!-- Notes Control -->
      <label
        for="{{ baseId }}-notes"
        translate
      >Notes</label>
      <textarea
        class="form-control"
        [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
        id="{{ baseId }}-notes"
        [maxlength]="fcListValidation.validations.Notes.MaxLength"
        formControlName="notes"
        rows="3"
      >
        </textarea>
      <div
        *ngIf="showErrors(notesControl, isSubmitted)"
        id="{{ baseId }}-warning-text-notes"
        class="incorrect-input"
        translate
      >
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
      <!-- Notes Control -->
    </div>
  </div>
</div>
